import { render, staticRenderFns } from "./allSelectModel.vue?vue&type=template&id=83c6a69e&scoped=true"
import script from "./allSelectModel.vue?vue&type=script&lang=js"
export * from "./allSelectModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c6a69e",
  null
  
)

export default component.exports